import * as React from 'react';

import { Action, Dispatch, bindActionCreators } from 'redux';
import { setOnSiteFromDate, setOnSiteToDate } from '../../redux/ui/actions';

import { DateSelector } from '../core/DateSelector';
import { RootState } from '../../redux/types';
import { connect } from 'react-redux';

export interface StateProps {
  onSiteFromDate: string;
  onSiteToDate: string;
}

export interface DispatchProps {
  actions: {
    setOnSiteFromDate: (date: string) => void;
    setOnSiteToDate: (date: string) => void;
  };
}

type OnSiteDayRangeSelectorProps = StateProps & DispatchProps;

class Component extends React.Component<OnSiteDayRangeSelectorProps> {
  public render(): JSX.Element {
    return (
      <div className="flex">
        <div style={{ marginRight: 10 }}>
          <DateSelector defaultDate={this.props.onSiteFromDate} displayFormat="Fro\m: MM/DD/YY" onChange={this.props.actions.setOnSiteFromDate} />
        </div>
        <div style={{ marginRight: 10 }}>
          <DateSelector defaultDate={this.props.onSiteToDate} displayFormat="To: MM/DD/YY" onChange={this.props.actions.setOnSiteToDate} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    onSiteFromDate: state.ui.onSiteFromDate,
    onSiteToDate: state.ui.onSiteToDate,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
  return {
    actions: bindActionCreators({ setOnSiteFromDate, setOnSiteToDate }, dispatch),
  };
};

export const OnSiteDayRangeSelector = connect(mapStateToProps, mapDispatchToProps)(Component);
